const QUEUE_ACTIONS_TYPES = {
  SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
  SET_NEW_CALL: "SET_NEW_CALL"
};

export default QUEUE_ACTIONS_TYPES;
